import { Logger } from '../utilities/logger';
import { AbstractComponent } from './abstract-component';
import { Collapse } from './collapse';
/**
 * Component for editing consent settings.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class Edit extends AbstractComponent {
    constructor(api, container) {
        var _a;
        super(api, container);
        // Edit container is optionally wrapped in a collapsible element
        this.collapse = null;
        Logger.debug('edit', 'Starting to construct.');
        // If the edit component is wrapped in a collapse container, initialize the collapse component
        if (((_a = container.parentElement) === null || _a === void 0 ? void 0 : _a.id) === 'a11y-consent-edit-collapse') {
            const collapseContainer = container.parentElement;
            // The collapse component is only initialized, if it has a custom A11y Consent class. Users may use e.g. the
            // default Bootstrap collapsible instead.
            if (collapseContainer && collapseContainer.classList.contains('a11y-consent-collapse')) {
                const showCollapseButtons = document.querySelectorAll(`[aria-controls="${container.parentElement.id}"]`);
                this.collapse = new Collapse(this.api, collapseContainer, showCollapseButtons);
            }
        }
        if (this.collapse) {
            this.api.emitter.on('acceptAll', () => {
                var _a;
                (_a = this.collapse) === null || _a === void 0 ? void 0 : _a.hide();
            });
            this.api.emitter.on('rejectAll', () => {
                var _a;
                (_a = this.collapse) === null || _a === void 0 ? void 0 : _a.hide();
            });
            this.api.emitter.on('save', () => {
                var _a;
                (_a = this.collapse) === null || _a === void 0 ? void 0 : _a.hide();
            });
            this.collapse.emitter.on('show', () => {
                this.api.updateOptionControls();
            });
        }
        Logger.debug('edit', 'Finished constructing.');
    }
}
